import { Category } from './category.model';

export class CommonCategories {
    all: Category[];
    folder: Category[];
    private: Category[];
}
